"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlEMVCardPayloadValidation = void 0;
const PaymentTerminalControlPaymentPresentedMethodValidation_1 = require("./PaymentTerminalControlPaymentPresentedMethodValidation");
class PaymentTerminalControlEMVCardPayloadValidation {
    static isValid(entity) {
        // Validate entity.card_payload for existence and correct type.
        if (entity.card_payload == undefined)
            return false;
        if (typeof entity.card_payload !== "string")
            return false;
        // Validate entity.valid_for_payment for existence and correct type.
        if (entity.valid_for_payment == undefined)
            return false;
        if (typeof entity.valid_for_payment !== "boolean")
            return false;
        // Validate entity.valid_for_membership for existence and correct type.
        if (entity.valid_for_membership == undefined)
            return false;
        if (typeof entity.valid_for_membership !== "boolean")
            return false;
        // Validate entity.payment_method for existence and correct type.
        if (entity.payment_method == undefined)
            return false;
        if (!PaymentTerminalControlPaymentPresentedMethodValidation_1.PaymentTerminalControlPaymentPresentedMethodValidation.isValid(entity.payment_method))
            return false;
        // If entity.membership_id exists, validate that it has the correct type.
        if (entity.membership_id != undefined) {
            if (typeof entity.membership_id !== "string")
                return false;
        }
        // If entity.card_bin exists, validate that it has the correct type.
        if (entity.card_bin != undefined) {
            if (!Array.isArray(entity.card_bin))
                return false;
            if (!entity.card_bin.every((elem) => {
                if (typeof elem !== "number")
                    return false;
                return true;
            }))
                return false;
        }
        // If entity.masked_track_2_data exists, validate that it has the correct type.
        if (entity.masked_track_2_data != undefined) {
            if (typeof entity.masked_track_2_data !== "string")
                return false;
        }
        // Validate entity.is_rfid for existence and correct type.
        if (entity.is_rfid == undefined)
            return false;
        if (typeof entity.is_rfid !== "boolean")
            return false;
        return true;
    }
}
exports.PaymentTerminalControlEMVCardPayloadValidation = PaymentTerminalControlEMVCardPayloadValidation;
